import {
  LocalizationProvider,
  MobileDatePicker,
} from '@mui/x-date-pickers-pro';
import { TextField, useTheme } from '@mui/material';

import AdapterJalaali from '@date-io/jalaali';
import { useState } from 'react';

function DatePicker({ value, onChange }) {
  const theme = useTheme();
  const [date , setDate] = useState(value)

  return (
    <LocalizationProvider dateAdapter={AdapterJalaali}>
      <MobileDatePicker
        inputFormat="jYYYY/jMM/jDD"
        renderInput={(params) => (
          <TextField placeholder="YYYY/MM/DD" {...params} />
        )}
        DialogProps={{
          PaperProps: {
            sx: {
              '.MuiButtonBase-root': {
                color: theme.palette.text.main,
              },
              '.MuiDialogActions-root': {
                '.MuiButtonBase-root:first-child': {
                  background: 'transparent !important',
                },
              },
            },
          },
        }}
        showToolbar={false}
        value={date}
        onAccept={onChange}
        onChange={($event) => setDate($event)}
      />
    </LocalizationProvider>
  );
}

export default DatePicker;
